"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotableElement = void 0;
/**
 * Interface for quotable elements
 */
const two_js_1 = __importDefault(require("two.js"));
const BallScrewElement_1 = require("./BallScrewElement");
const Quote_1 = require("./Quote");
const Rows_1 = require("./Rows");
class QuotableElement {
    constructor() {
        this.quotes = [];
        this.quoteOpacity = 1;
        this.quoteLineWidth = 0.6;
    }
    /**
     * Method to register an element for quotes
     * @param elem
     * @param position
     * @param distance
     * @param message
     * @param rotate
     * @param color
     */
    registerForQuote(elem, position, distance, message, rotate = false, color = BallScrewElement_1.BallScrewElement.COLORQUOTE, ignoreLeft = false, ignoreRight = false, extendDirection = "") {
        this.quotes.push(new Quote_1.Quote(elem, position, distance, message, color, rotate, ignoreLeft, ignoreRight, extendDirection));
    }
    /**
     * Show all registered quotes
     */
    showQuotes(scaleFactor) {
        for (const quote of this.quotes) {
            this.drawQuoteOnElement(quote, scaleFactor);
        }
        this.two.update();
    }
    /**
     * Method to hide quotes
     */
    hideQuotes() {
        for (const quote of this.quotes) {
            for (const part of quote.quotesPart) {
                this.group.remove(part);
            }
        }
        this.two.update();
    }
    /**
     * Draw quote on a single element
     * @param quote
     */
    drawQuoteOnElement(quote, scaleFactor) {
        if (quote.elem.length === 1) {
            if (quote.elem[0] instanceof two_js_1.default.Circle) {
                this.drawQuoteOnCircle(quote, scaleFactor);
            }
            else {
                this.drawQuoteOnSingleElement(quote, scaleFactor);
            }
        }
        else {
            this.drawQuoteBetweenTwoElement(quote, scaleFactor);
        }
    }
    /**
     * Draw quote between two element
     * @param quote
     */
    drawQuoteBetweenTwoElement(quote, scaleFactor) {
        const rect1 = quote.elem[0];
        const rect2 = quote.elem[1];
        // Left quote on left elemen
        if (!quote.ignoreLeft) {
            const quote1 = this.createLeftQuoteOnElement(rect1, quote, scaleFactor);
            this.group.add(quote1);
            quote.quotesPart.push(quote1);
        }
        // Right quote on right element
        if (!quote.ignoreRight) {
            const quote2 = this.createRightQuoteOnElement(rect2, quote, scaleFactor);
            this.group.add(quote2);
            quote.quotesPart.push(quote2);
        }
        // Quote vertices
        const leftQuoteVertices = this.getLeftVertices(rect1, quote, scaleFactor);
        const rightQuoteVertices = this.getRightVertices(rect2, quote, scaleFactor);
        let quote3 = null;
        if (quote.position === "bottom") {
            quote3 = this.two.makeLine(rect1.translation.x - (rect1.width / 2), rect1.translation.y + (quote.distance * scaleFactor) - 10, rect2.translation.x + (rect2.width / 2), rect1.translation.y + (quote.distance * scaleFactor) - 10);
            const left = Rows_1.Rows.makeArrow("left");
            left.translation.set(rect1.translation.x - (rect1.width / 2) - 4, rect1.translation.y + (quote.distance * scaleFactor) - 17);
            this.group.add(left);
            quote.quotesPart.push(left);
            const right = Rows_1.Rows.makeArrow("right");
            right.translation.set(rightQuoteVertices[0] - 10, rect1.translation.y + (quote.distance * scaleFactor) - 17);
            this.group.add(right);
            quote.quotesPart.push(right);
        }
        else if (quote.position === "top") {
            quote3 = this.two.makeLine(rect1.translation.x - (rect1.width / 2), rect1.translation.y - (quote.distance * scaleFactor) + 10, rect2.translation.x + (rect2.width / 2), rect1.translation.y - (quote.distance * scaleFactor) + 10);
            const left = Rows_1.Rows.makeArrow("left");
            left.translation.set(rect1.translation.x - (rect1.width / 2) - 4, rect1.translation.y - (quote.distance * scaleFactor) + 3);
            this.group.add(left);
            quote.quotesPart.push(left);
            const right = Rows_1.Rows.makeArrow("right");
            right.translation.set(rect2.translation.x + (rect2.width / 2) - 10, rect1.translation.y - (quote.distance * scaleFactor) + 3);
            this.group.add(right);
            quote.quotesPart.push(right);
        }
        else if (quote.position === "left") { }
        quote3.linewidth = this.quoteLineWidth;
        quote3.stroke = quote.color;
        quote3.opacity = this.quoteOpacity;
        this.group.add(quote3);
        quote.quotesPart.push(quote3);
        let yQuote = 0;
        let xQuote = leftQuoteVertices[0] + ((rightQuoteVertices[0] - leftQuoteVertices[0]) / 2);
        if (quote.position === "bottom") {
            yQuote = rect1.translation.y + (quote.distance * scaleFactor);
        }
        else if (quote.position === "top") {
            yQuote = rect1.translation.y - (quote.distance * scaleFactor);
        }
        else if (quote.position === "left") {
            yQuote = rect1.translation.y;
            xQuote = rect1.translation.x - (rect1.width / 2) - (rect1.height * quote.distance) + 20;
        }
        const text = this.two.makeText(quote.message, xQuote, yQuote + ((quote.rotate) ? 18 : -18), QuotableElement.STYLE_CENTER);
        text.fill = quote.color;
        if (quote.rotate) {
            text.rotation = Math.PI;
        }
        this.group.add(text);
        quote.quotesPart.push(text);
    }
    /**
     * Calculate left vertices for quote on element
     * @param elem
     * @param quote
     */
    getLeftVertices(elem, quote, scaleFactor) {
        const rect = elem;
        const rectWith = rect.width;
        const rectHeight = rect.height;
        if (quote.position === "bottom") {
            return [
                rect.translation.x - (rectWith / 2),
                rect.translation.y + (rectHeight / 2) + 3,
                rect.translation.x - (rectWith / 2),
                rect.translation.y + (quote.distance * scaleFactor),
            ];
        }
        else if (quote.position === "top") {
            return [
                rect.translation.x - (rectWith / 2),
                rect.translation.y - (rectHeight / 2) - 3,
                rect.translation.x - (rectWith / 2),
                rect.translation.y - (quote.distance * scaleFactor),
            ];
        }
        else if (quote.position === "left") {
            return [
                rect.translation.x - (rectWith / 2),
                rect.translation.y - (rectHeight / 2),
                rect.translation.x - (rectWith / 2) - rectHeight,
                rect.translation.y - (rectHeight / 2),
            ];
        }
        else if (quote.position === "right") {
            return [
                rect.translation.x + (rectWith / 2),
                rect.translation.y - (rectHeight / 2),
                rect.translation.x + (rectWith / 2) + rectHeight,
                rect.translation.y - (rectHeight / 2),
            ];
        }
    }
    /**
     * Calculate right vertices for quote on element
     * @param elem
     * @param quote
     */
    getRightVertices(elem, quote, scaleFactor) {
        const rect = elem;
        const rectWith = rect.width;
        const rectHeight = rect.height;
        if (quote.position === "bottom") {
            return [
                rect.translation.x + (rectWith / 2),
                rect.translation.y + (rectHeight / 2) + 3,
                rectWith + rect.translation.x - (rectWith / 2),
                rect.translation.y + (quote.distance * scaleFactor),
            ];
        }
        else if (quote.position === "top") {
            return [
                rectWith + rect.translation.x - (rectWith / 2),
                rect.translation.y - (rectHeight / 2) - 3,
                rectWith + rect.translation.x - (rectWith / 2),
                rect.translation.y - (quote.distance * scaleFactor),
            ];
        }
        else if (quote.position === "left") {
            return [
                rect.translation.x - (rectWith / 2),
                rect.translation.y + (rectHeight / 2),
                rect.translation.x - (rectWith / 2) - (rectHeight * quote.distance),
                rect.translation.y + (rectHeight / 2),
            ];
        }
        else if (quote.position === "right") {
            return [
                rect.translation.x + (rectWith / 2),
                rect.translation.y + rectHeight / 2,
                rect.translation.x + (rectWith / 2) + (rectHeight * quote.distance),
                rect.translation.y + rectHeight / 2,
            ];
        }
    }
    /**
     * Create left side quote
     * @param elem
     * @param quote
     */
    createLeftQuoteOnElement(elem, quote, scaleFactor) {
        const vertices = this.getLeftVertices(elem, quote, scaleFactor);
        const quote1 = this.two.makeLine(vertices[0], vertices[1], vertices[2], vertices[3]);
        quote1.linewidth = this.quoteLineWidth;
        quote1.stroke = quote.color;
        quote1.opacity = this.quoteOpacity;
        return quote1;
    }
    /**
     * Create right side quote for element
     * @param elem
     * @param quote
     */
    createRightQuoteOnElement(elem, quote, scaleFactor) {
        const vertices = this.getRightVertices(elem, quote, scaleFactor);
        const quote1 = this.two.makeLine(vertices[0], vertices[1], vertices[2], vertices[3]);
        quote1.linewidth = this.quoteLineWidth;
        quote1.stroke = quote.color;
        quote1.opacity = this.quoteOpacity;
        return quote1;
    }
    /**
     * Draw a quote on a single circle element
     * @param quote
     */
    drawQuoteOnCircle(quote, scaleFactor) {
        const rect = quote.elem[0];
        const quoteGroup = this.two.makeGroup();
        quoteGroup.translation.set(rect.translation.x, rect.translation.y);
        this.two.update();
        const upperQuoteWidth = rect.radius + 80;
        const upperQuote = this.two.makeLine(rect.radius, 0, upperQuoteWidth, 0);
        const rotation = quote.distance;
        upperQuote.linewidth = this.quoteLineWidth;
        upperQuote.stroke = quote.color;
        upperQuote.linewidth = 1;
        upperQuote.opacity = this.quoteOpacity;
        upperQuote.addTo(quoteGroup);
        const yHorizontal = rect.translation.y + ((upperQuoteWidth) * Math.sin(rotation));
        const xHorizontal = rect.translation.x + ((upperQuoteWidth) * Math.cos(rotation));
        const upperLineQuote = this.two.makeLine(xHorizontal + 60, yHorizontal, xHorizontal, yHorizontal);
        upperLineQuote.linewidth = this.quoteLineWidth;
        upperLineQuote.stroke = quote.color;
        upperLineQuote.linewidth = 1;
        upperLineQuote.opacity = this.quoteOpacity;
        upperLineQuote.addTo(this.group);
        const right = Rows_1.Rows.makeArrow("left");
        right.translation.set(rect.radius - 4, -7);
        right.addTo(quoteGroup);
        const lowerQuote = this.two.makeLine(-rect.radius, 0, -rect.radius - 15, 0);
        lowerQuote.linewidth = this.quoteLineWidth;
        lowerQuote.linewidth = 1;
        lowerQuote.opacity = this.quoteOpacity;
        lowerQuote.addTo(quoteGroup);
        const left = Rows_1.Rows.makeArrow("right");
        left.translation.set(-rect.radius - 10, -7);
        left.addTo(quoteGroup);
        const text = this.two.makeText(quote.message, xHorizontal + 10, yHorizontal - 10, QuotableElement.STYLE_LEFT);
        text.fill = quote.color;
        this.group.add(text);
        quoteGroup.addTo(this.group);
        quoteGroup.rotation = rotation;
        this.two.update();
    }
    /**
     * Draw a quote on a single element
     * @param quote
     */
    drawQuoteOnSingleElement(quote, scaleFactor) {
        const rect = quote.elem[0];
        const rectWith = rect.width;
        const rectHeight = rect.height;
        if (quote.position === "inner") {
            const innerQuote = this.two.makeLine(rect.translation.x, rect.translation.y - (rectHeight / 2), rect.translation.x, rect.translation.y + (rectHeight / 2));
            innerQuote.linewidth = this.quoteLineWidth;
            innerQuote.stroke = quote.color;
            innerQuote.opacity = this.quoteOpacity;
            this.group.add(innerQuote);
            quote.quotesPart.push(innerQuote);
            const text = this.two.makeText(quote.message, rect.translation.x - 6, rect.translation.y, QuotableElement.STYLE_CENTER);
            text.rotation = -(Math.PI / 2);
            text.fill = quote.color;
            this.group.add(text);
            quote.quotesPart.push(text);
            const up = Rows_1.Rows.makeArrow();
            up.translation.set(rect.translation.x - 7, rect.translation.y - (rectHeight / 2) - 4);
            this.group.add(up);
            quote.quotesPart.push(up);
            const down = Rows_1.Rows.makeArrow("down");
            down.translation.set(rect.translation.x - 7, rect.translation.y + (rectHeight / 2) - 11);
            this.group.add(down);
            quote.quotesPart.push(down);
        }
        else if (quote.position === "outerleft") {
            const upperQuote = this.two.makeLine(20, rect.translation.y - (rectHeight / 2), 20, rect.translation.y - (rectHeight / 2) - 80);
            upperQuote.linewidth = this.quoteLineWidth;
            upperQuote.stroke = quote.color;
            upperQuote.opacity = this.quoteOpacity;
            this.group.add(upperQuote);
            quote.quotesPart.push(upperQuote);
            const lowerQuote = this.two.makeLine(20, rect.translation.y + (rectHeight / 2), 20, rect.translation.y + (rectHeight / 2) + 20);
            lowerQuote.linewidth = this.quoteLineWidth;
            lowerQuote.stroke = quote.color;
            lowerQuote.opacity = this.quoteOpacity;
            this.group.add(lowerQuote);
            quote.quotesPart.push(lowerQuote);
            const text = this.two.makeText(quote.message, 13, rect.translation.y - (rectHeight / 2) - 20, QuotableElement.STYLE_LEFT);
            text.rotation = -(Math.PI / 2);
            text.fill = quote.color;
            this.group.add(text);
            quote.quotesPart.push(text);
            const up = Rows_1.Rows.makeArrow("down");
            up.translation.set(13, rect.translation.y - (rectHeight / 2) - 11);
            this.group.add(up);
            quote.quotesPart.push(up);
            const down = Rows_1.Rows.makeArrow();
            down.translation.set(13, rect.translation.y + (rectHeight / 2) - 4);
            this.group.add(down);
            quote.quotesPart.push(down);
        }
        else if (quote.position === "outerright") {
            const upperQuote = this.two.makeLine(rect.translation.x + (rectWith / 2) - 10, rect.translation.y - (rectHeight / 2), rect.translation.x + (rectWith / 2) - 10, rect.translation.y - (rectHeight / 2) - 80);
            upperQuote.linewidth = this.quoteLineWidth;
            upperQuote.stroke = quote.color;
            upperQuote.opacity = this.quoteOpacity;
            this.group.add(upperQuote);
            quote.quotesPart.push(upperQuote);
            const lowerQuote = this.two.makeLine(rect.translation.x + (rectWith / 2) - 10, rect.translation.y + (rectHeight / 2), rect.translation.x + (rectWith / 2) - 10, rect.translation.y + (rectHeight / 2) + 20);
            lowerQuote.linewidth = this.quoteLineWidth;
            lowerQuote.stroke = quote.color;
            lowerQuote.opacity = this.quoteOpacity;
            this.group.add(lowerQuote);
            quote.quotesPart.push(lowerQuote);
            const text = this.two.makeText(quote.message, rect.translation.x + (rectWith / 2) - 17, rect.translation.y - (rectHeight / 2) - 40, QuotableElement.STYLE_LEFT);
            text.rotation = -(Math.PI / 2);
            text.fill = quote.color;
            this.group.add(text);
            quote.quotesPart.push(text);
            const up = Rows_1.Rows.makeArrow("down");
            up.translation.set(rect.translation.x + (rectWith / 2) - 17, rect.translation.y - (rectHeight / 2) - 11);
            this.group.add(up);
            quote.quotesPart.push(up);
            const down = Rows_1.Rows.makeArrow();
            down.translation.set(rect.translation.x + (rectWith / 2) - 17, rect.translation.y + (rectHeight / 2) - 4);
            this.group.add(down);
            quote.quotesPart.push(down);
        }
        else if (quote.position === "outercenter") {
            const upperQuote = this.two.makeLine(rect.translation.x + quote.distance, rect.translation.y - (rectHeight / 2), rect.translation.x + quote.distance, rect.translation.y - (rectHeight / 2) - (quote.rotate ? 20 : 80));
            upperQuote.linewidth = this.quoteLineWidth;
            upperQuote.stroke = quote.color;
            upperQuote.opacity = this.quoteOpacity;
            this.group.add(upperQuote);
            quote.quotesPart.push(upperQuote);
            const lowerQuote = this.two.makeLine(rect.translation.x + quote.distance, rect.translation.y + (rectHeight / 2), rect.translation.x + quote.distance, rect.translation.y + (rectHeight / 2) + (quote.rotate ? 80 : 20));
            lowerQuote.linewidth = this.quoteLineWidth;
            lowerQuote.stroke = quote.color;
            lowerQuote.opacity = this.quoteOpacity;
            this.group.add(lowerQuote);
            quote.quotesPart.push(lowerQuote);
            // Add translated line for quote
            if (quote.distance !== 0) {
                const upperQuoteTranslate = this.two.makeLine(rect.translation.x + rectWith / 2, rect.translation.y - (rectHeight / 2), rect.translation.x + quote.distance + 5, rect.translation.y - (rectHeight / 2));
                upperQuoteTranslate.linewidth = this.quoteLineWidth;
                upperQuoteTranslate.stroke = quote.color;
                upperQuoteTranslate.opacity = this.quoteOpacity;
                this.group.add(upperQuoteTranslate);
                quote.quotesPart.push(upperQuoteTranslate);
                const lowerQuoteTranslate = this.two.makeLine(rect.translation.x + rectWith / 2, rect.translation.y + (rectHeight / 2), rect.translation.x + quote.distance + 5, rect.translation.y + (rectHeight / 2));
                lowerQuoteTranslate.linewidth = this.quoteLineWidth;
                lowerQuoteTranslate.stroke = quote.color;
                lowerQuoteTranslate.opacity = this.quoteOpacity;
                this.group.add(lowerQuoteTranslate);
                quote.quotesPart.push(lowerQuoteTranslate);
            }
            const text = this.two.makeText(quote.message, rect.translation.x + quote.distance + (quote.rotate ? 7 : -7), rect.translation.y - (rectHeight / 2) + (quote.rotate ? rectHeight + 30 : -30), QuotableElement.STYLE_LEFT);
            text.rotation = (quote.rotate ? 1 : -1) * (Math.PI / 2);
            text.fill = quote.color;
            this.group.add(text);
            quote.quotesPart.push(text);
            const up = Rows_1.Rows.makeArrow("down");
            up.translation.set(rect.translation.x - 7 + quote.distance, rect.translation.y - (rectHeight / 2) - 11);
            this.group.add(up);
            quote.quotesPart.push(up);
            const down = Rows_1.Rows.makeArrow();
            down.translation.set(rect.translation.x - 7 + quote.distance, rect.translation.y + (rectHeight / 2) - 4);
            this.group.add(down);
            quote.quotesPart.push(down);
        }
        else if (quote.position === "outerleftsingle") {
            const upperQuote = this.two.makeLine(rect.translation.x - rectWith / 2 + 10, rect.translation.y + ((quote.rotate) ? 1 : -1) * (rectHeight / 2), rect.translation.x - rectWith / 2 + 10, rect.translation.y + ((quote.rotate) ? 1 : -1) * ((rectHeight / 2) + quote.distance));
            upperQuote.linewidth = this.quoteLineWidth;
            upperQuote.stroke = quote.color;
            upperQuote.opacity = this.quoteOpacity;
            this.group.add(upperQuote);
            quote.quotesPart.push(upperQuote);
            const text = this.two.makeText(quote.message, rect.translation.x - rectWith / 2 + ((quote.rotate) ? 16 : 3), rect.translation.y + ((quote.rotate) ? 1 : -1) * (rectHeight / 2) + ((quote.rotate) ? 45 : -45), QuotableElement.STYLE_LEFT);
            text.rotation = (quote.rotate) ? Math.PI / 2 : -(Math.PI / 2);
            text.fill = quote.color;
            this.group.add(text);
            quote.quotesPart.push(text);
            const up = Rows_1.Rows.makeArrow((quote.rotate) ? "up" : "down");
            up.translation.set(rect.translation.x - rectWith / 2 + 3, rect.translation.y + ((quote.rotate) ? 1 : -1) * (rectHeight / 2) + ((quote.rotate) ? -3 : -11));
            this.group.add(up);
            quote.quotesPart.push(up);
        }
        else if (quote.position === "distance") {
            const quoteLeft = this.two.makeLine(rect.translation.x + (rectWith / 2), rect.translation.y, rect.translation.x + (rectWith / 2), rect.translation.y + ((quote.rotate ? -1 : 1) * (quote.distance * scaleFactor)));
            quoteLeft.linewidth = this.quoteLineWidth;
            quoteLeft.stroke = quote.color;
            quoteLeft.opacity = this.quoteOpacity;
            this.group.add(quoteLeft);
            quote.quotesPart.push(quoteLeft);
            const gap = (quote.rotate ? 12 : -12);
            const quoteRight = this.two.makeLine(rect.translation.x + (rectWith / 2) + parseFloat(quote.extendDirection) * scaleFactor + 1, rect.translation.y + ((quote.rotate ? -1 : 1) * (quote.distance * scaleFactor) + gap), rect.translation.x + (rectWith / 2) + parseFloat(quote.extendDirection) * scaleFactor + 20, rect.translation.y + ((quote.rotate ? -1 : 1) * (quote.distance * scaleFactor) + gap));
            quoteRight.linewidth = this.quoteLineWidth;
            quoteRight.stroke = quote.color;
            quoteRight.opacity = this.quoteOpacity;
            this.group.add(quoteRight);
            quote.quotesPart.push(quoteRight);
            const lowerQuote = this.two.makeLine(rect.translation.x + (rectWith / 2), rect.translation.y + ((quote.rotate ? -1 : 1) * (quote.distance * scaleFactor) + gap), rect.translation.x + (quote.rotate ? 10 : -10), rect.translation.y + ((quote.rotate ? -1 : 1) * (quote.distance * scaleFactor) + gap));
            lowerQuote.linewidth = this.quoteLineWidth;
            lowerQuote.stroke = quote.color;
            lowerQuote.opacity = this.quoteOpacity;
            this.group.add(lowerQuote);
            quote.quotesPart.push(lowerQuote);
            const text = this.two.makeText(quote.message, rect.translation.x + (rectWith / 2) - (quote.rotate ? 20 : 40), rect.translation.y + ((quote.rotate ? -1 : 1) * ((quote.distance * scaleFactor) - 20)), QuotableElement.STYLE_LEFT);
            text.fill = quote.color;
            if (quote.rotate) {
                text.rotation = Math.PI;
            }
            this.group.add(text);
            quote.quotesPart.push(text);
            const left = Rows_1.Rows.makeArrow("right");
            const scaleDist = quote.distance * scaleFactor;
            left.translation.set(rect.translation.x + (rectWith / 2) - 10, rect.translation.y + (quote.rotate ? (-(scaleDist) + 5) : ((scaleDist) - 19)));
            this.group.add(left);
            quote.quotesPart.push(left);
            const right = Rows_1.Rows.makeArrow("left");
            right.translation.set(rect.translation.x + (rectWith / 2) + parseFloat(quote.extendDirection) * scaleFactor - 1, rect.translation.y + (quote.rotate ? (-(scaleDist) + 5) : ((scaleDist) - 19)));
            this.group.add(right);
            quote.quotesPart.push(right);
        }
        else {
            // Left quote
            if (!quote.ignoreLeft) {
                const quote1 = this.createLeftQuoteOnElement(rect, quote, scaleFactor);
                this.group.add(quote1);
                quote.quotesPart.push(quote1);
            }
            // Right quote
            if (!quote.ignoreRight) {
                const quote2 = this.createRightQuoteOnElement(rect, quote, scaleFactor);
                this.group.add(quote2);
                quote.quotesPart.push(quote2);
            }
            let quote3 = null;
            if (quote.position === "bottom") {
                if (rect.width >= 15) {
                    quote3 = this.two.makeLine(rect.translation.x - (rectWith / 2), rect.translation.y + (quote.distance * scaleFactor) - 10, rectWith + rect.translation.x - (rectWith / 2), rect.translation.y + (quote.distance * scaleFactor) - 10);
                    const left = Rows_1.Rows.makeArrow("left");
                    left.translation.set(rect.translation.x - (rectWith / 2) - 4, rect.translation.y + (quote.distance * scaleFactor) - 17);
                    this.group.add(left);
                    quote.quotesPart.push(left);
                    const right = Rows_1.Rows.makeArrow("right");
                    right.translation.set(rectWith + rect.translation.x - (rectWith / 2) - 10, rect.translation.y + (quote.distance * scaleFactor) - 17);
                    this.group.add(right);
                    quote.quotesPart.push(right);
                }
                else {
                    const upperQuote = this.two.makeLine(rect.translation.x - (rectWith / 2), rect.translation.y + (quote.distance * scaleFactor) - 10, rect.translation.x + (quote.extendDirection === "left" ? -45 : -20), rect.translation.y + (quote.distance * scaleFactor) - 10);
                    upperQuote.linewidth = this.quoteLineWidth;
                    upperQuote.stroke = quote.color;
                    upperQuote.opacity = this.quoteOpacity;
                    this.group.add(upperQuote);
                    quote.quotesPart.push(upperQuote);
                    const lowerQuote = this.two.makeLine(rect.translation.x + (rectWith / 2), rect.translation.y + (quote.distance * scaleFactor) - 10, rect.translation.x + (quote.extendDirection === "left" ? 20 : 45), rect.translation.y + (quote.distance * scaleFactor) - 10);
                    lowerQuote.linewidth = this.quoteLineWidth;
                    lowerQuote.stroke = quote.color;
                    lowerQuote.opacity = this.quoteOpacity;
                    this.group.add(lowerQuote);
                    quote.quotesPart.push(lowerQuote);
                    const text = this.two.makeText(quote.message, rect.translation.x + ((quote.extendDirection === "left" ? -1 : 1) * ((rectWith / 2) + 20)), rect.translation.y + (quote.distance * scaleFactor) - 18, QuotableElement.STYLE_LEFT);
                    text.fill = quote.color;
                    if (quote.rotate) {
                        text.rotation = Math.PI;
                    }
                    this.group.add(text);
                    quote.quotesPart.push(text);
                    const left = Rows_1.Rows.makeArrow("right");
                    left.translation.set(rect.translation.x - (rectWith / 2) - 10, rect.translation.y + (quote.distance * scaleFactor) - 17);
                    this.group.add(left);
                    quote.quotesPart.push(left);
                    const right = Rows_1.Rows.makeArrow("left");
                    right.translation.set(rectWith + rect.translation.x - (rectWith / 2) - 4, rect.translation.y + (quote.distance * scaleFactor) - 17);
                    this.group.add(right);
                    quote.quotesPart.push(right);
                }
            }
            else if (quote.position === "top") {
                if (rect.width >= 15) {
                    quote3 = this.two.makeLine(rect.translation.x - (rectWith / 2), rect.translation.y - (quote.distance * scaleFactor) + 10, rectWith + rect.translation.x - (rectWith / 2), rect.translation.y - (quote.distance * scaleFactor) + 10);
                    const left = Rows_1.Rows.makeArrow("left");
                    left.translation.set(rect.translation.x - (rectWith / 2) - 4, rect.translation.y - (quote.distance * scaleFactor) + 3);
                    this.group.add(left);
                    quote.quotesPart.push(left);
                    const right = Rows_1.Rows.makeArrow("right");
                    right.translation.set(rectWith + rect.translation.x - (rectWith / 2) - 10, rect.translation.y - (quote.distance * scaleFactor) + 3);
                    this.group.add(right);
                    quote.quotesPart.push(right);
                }
                else {
                    const upperQuote = this.two.makeLine(rect.translation.x - (rectWith / 2), rect.translation.y - (quote.distance * scaleFactor) + 10, rect.translation.x - 20, rect.translation.y - (quote.distance * scaleFactor) + 10);
                    upperQuote.linewidth = this.quoteLineWidth;
                    upperQuote.stroke = quote.color;
                    upperQuote.opacity = this.quoteOpacity;
                    this.group.add(upperQuote);
                    quote.quotesPart.push(upperQuote);
                    const lowerQuote = this.two.makeLine(rect.translation.x + (rectWith / 2), rect.translation.y - (quote.distance * scaleFactor) + 10, rect.translation.x + (rectWith / 2) + 65, rect.translation.y - (quote.distance * scaleFactor) + 10);
                    lowerQuote.linewidth = this.quoteLineWidth;
                    lowerQuote.stroke = quote.color;
                    lowerQuote.opacity = this.quoteOpacity;
                    this.group.add(lowerQuote);
                    quote.quotesPart.push(lowerQuote);
                    const text = this.two.makeText(quote.message, rect.translation.x + (rectWith / 2) + 40, rect.translation.y - (quote.distance * scaleFactor) + 18, QuotableElement.STYLE_CENTER);
                    text.fill = quote.color;
                    if (quote.rotate) {
                        text.rotation = Math.PI;
                    }
                    this.group.add(text);
                    quote.quotesPart.push(text);
                    const left = Rows_1.Rows.makeArrow("right");
                    left.translation.set(rect.translation.x - (rectWith / 2) - 10, rect.translation.y - (quote.distance * scaleFactor) + 3);
                    this.group.add(left);
                    quote.quotesPart.push(left);
                    const right = Rows_1.Rows.makeArrow("left");
                    right.translation.set(rectWith + rect.translation.x - (rectWith / 2) - 4, rect.translation.y - (quote.distance * scaleFactor) + 3);
                    this.group.add(right);
                    quote.quotesPart.push(right);
                }
            }
            else if (quote.position === "left") {
                quote3 = this.two.makeLine(rect.translation.x - (rectWith / 2) - (rectHeight * quote.distance) + 10, rect.translation.y - (rectHeight / 2), rect.translation.x - (rectWith / 2) - (rectHeight * quote.distance) + 10, rect.translation.y + (rectHeight / 2));
                const up = Rows_1.Rows.makeArrow();
                up.translation.set(rect.translation.x - (rectWith / 2) - (rectHeight * quote.distance) + 3, rect.translation.y - (rectHeight / 2) - 4);
                this.group.add(up);
                quote.quotesPart.push(up);
                const down = Rows_1.Rows.makeArrow("down");
                down.translation.set(rect.translation.x - (rectWith / 2) - (rectHeight * quote.distance) + 3, rect.translation.y + (rectHeight / 2) - 10);
                this.group.add(down);
                quote.quotesPart.push(down);
            }
            else if (quote.position === "right") {
                quote3 = this.two.makeLine(rect.translation.x + (rectWith / 2) + (rectHeight * quote.distance) - 10, rect.translation.y - (rectHeight / 2), rect.translation.x + (rectWith / 2) + (rectHeight * quote.distance) - 10, rect.translation.y + (rectHeight / 2));
            }
            if (quote3 != null) {
                quote3.linewidth = this.quoteLineWidth;
                quote3.stroke = quote.color;
                quote3.opacity = this.quoteOpacity;
                this.group.add(quote3);
                quote.quotesPart.push(quote3);
                let yQuote = quote3.vertices[1].y + (quote.rotate ? 9 : -9);
                let xQuote = rect.translation.x;
                if (quote.position === "left") {
                    yQuote = rect.translation.y;
                    xQuote = rect.translation.x - (rectWith / 2) - (rectHeight * quote.distance) + 20;
                }
                else if (quote.position === "right") {
                    yQuote = rect.translation.y;
                    xQuote = rect.translation.x + (rectWith / 2) + (rectHeight * quote.distance) - 20;
                }
                const text = this.two.makeText(quote.message, xQuote, yQuote, QuotableElement.STYLE_CENTER);
                if (quote.position === "top") {
                    text.rotation = -Math.PI;
                }
                text.fill = quote.color;
                this.group.add(text);
                quote.quotesPart.push(text);
            }
        }
        this.two.update();
    }
}
exports.QuotableElement = QuotableElement;
QuotableElement.COLORQUOTE = "#007AC9";
QuotableElement.STYLE_CENTER = {
    family: "proxima-nova, sans-serif",
    size: 11,
    weight: 100,
};
QuotableElement.STYLE_LEFT = {
    alignment: "left",
    family: "proxima-nova, sans-serif",
    size: 11,
    weight: 100,
};
QuotableElement.STYLE_RIGHT = {
    alignment: "right",
    family: "proxima-nova, sans-serif",
    size: 11,
    weight: 100,
};
